import Vue from 'vue';
import TheGroup from './components/TheGroup.vue';
import TheConfigParams from './components/TheConfigParams.vue';
import TheTabsItem from './components/TheTabsItem.vue';
import TheTabMenu from './components/TheTabMenu.vue';
import TheTabImage from './components/TheTabImage.vue';
import TheApp from './components/TheApp.vue';

Vue.component('TheApp', TheApp)
Vue.component('TheGroup', TheGroup)
Vue.component('TheTabsItem', TheTabsItem)
Vue.component('TheTabMenu', TheTabMenu)
Vue.component('TheTabImage', TheTabImage)
Vue.component('TheConfigParams', TheConfigParams)
